// extracted by mini-css-extract-plugin
export default {"btn":"ButtonWithIcon_btn__-RNwv","btn__text":"ButtonWithIcon_btn__text__d4PdI","btn__icon":"ButtonWithIcon_btn__icon__aiuO4"};